<template>
  <div>
    <top-nav>
      <router-link to="/">登录</router-link>
    </top-nav>
    <div class="forget-container">
      <h1 class="forget-title">忘记密码</h1>
      <hr />
      <div class="step-left-div">
        <div class="step-left" :class="{'active-step': step >= 1}">
          <div>
            <div @click="goStep(1)" class="num">1</div>
            <div class="line"></div>
          </div>
          <div class="text">手机号确认</div>
        </div>
        <div class="step-left" :class="{'active-step': step >= 2}">
          <div>
            <div class="num">2</div>
            <div class="line"></div>
          </div>
          <div class="text">修改密码</div>
        </div>
        <div class="step-left step-last" :class="{'active-step': step >= 3}">
          <div>
            <div class="num">3</div>
            <div style="width:20px;" class="line"></div>
          </div>
          <div style="margin-left:-6px;" class="text">完成</div>
        </div>
      </div>
      <div v-show="step === 1" class="forget-input">
        <div class="input-wrap">
          <input
            type="text"
            :class="{'err-input': errFields['phone']}"
            placeholder="请输入手机号码"
            v-model="phone"
          />
        </div>
        <div class="input-wrap">
          <Slider
            class="input-border"
            @failed="isSlide = false"
            :sfunc="slideCheck"
            @success="slideSuccess"
          />
        </div>
        <div v-if="isSlide" class="input-wrap">
          <input
            type="text"
            :class="{'err-input': errFields['code']}"
            placeholder="短信验证码"
            maxlength="6"
            @change="doCheckCode"
            v-model="code"
            class="code-input"
          />
          <button :class="{'active-btn': canCode}" @click="doSendCode" class="code-tip">{{codeTip}}</button>
        </div>
      </div>
      <div v-show="step === 2" class="forget-input">
        <div class="input-wrap">
          <input
            type="password"
            maxlength="18"
            :class="{'err-input': errFields['password']}"
            placeholder="6-18位密码，字母/数字/符号至少两种"
            v-model="password"
          />
        </div>
        <div class="input-wrap">
          <input
            type="password"
            maxlength="18"
            :class="{'err-input': errFields['cfmpassword']}"
            placeholder="密码确认"
            v-model="cfmpassword"
          />
        </div>
      </div>
      <div v-if="step === 3" class="forget-input">
        <svg-icon icon-class="suss" class="suss-icon" />
        <label class="suss-text">密码修改成功</label>
        <label>
          <span>去</span>
          <router-link class="login-link" to="/">登录></router-link>
        </label>
      </div>
      <div v-if="step < 3" class="login-btn-container input-wrap">
        <button @click="doNext" class="login-button" :class="{'active-btn': isCode}">下一步</button>
        <span class="error">{{errMsg}}</span>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopNav from "../components/TopNav.vue";
import Footer from "../components/Footer.vue";
import Slider from "../components/Slider.vue";

import { sendCode, checkCode, setPassword } from "@/api/login";
import { isPoneAvailable, isvalidPassword } from "@/utils/validate";
const DEFAULT_TIP_TEXT = "获取验证码";
export default {
  name: "Forget",
  components: {
    TopNav,
    Footer,
    Slider
  },
  props: {
    msg: String
  },
  data() {
    return {
      step: 1,
      codeTip: DEFAULT_TIP_TEXT,
      errFields: {},
      errMsg: "",
      isSlide: false,
      isCode: false,
      canCode: false,
      phone: "",
      code: "",
      password: "",
      cfmpassword: "",
      sliderCode: ""
    };
  },

  destroyed() {
    if (this.tickTime) {
      clearInterval(this.tickTime);
    }
  },

  watch: {
    phone() {
      this.clearErr();
      if (!isPoneAvailable(this.phone)) {
        this.$nextTick(() => {
          this.$set(this.errFields, "phone", "手机号码不正确");
          this.errMsg = "手机号码不正确";
        });
      }
    },
    password() {
      this.clearErr();
      if (!isvalidPassword(this.password)) {
        this.$nextTick(() => {
          this.$set(
            this.errFields,
            "password",
            "密码不合法，字母/数字/字符至少包含两类"
          );
          this.errMsg = "6-18位，字母/数字/字符至少包含两类";
        });
      }
    },
    code() {
      this.clearErr();
    }
  },

  methods: {
    doNext() {
      if (!this.isCode) {
        return;
      }
      if (!this.phone) {
        this.$set(this.errFields, "phone", "手机号码必须提供");
      }
      if (!this.code) {
        this.$set(this.errFields, "code", "验证码必须提供");
      }
      this.clearErr();
      if (this.step === 2) {
        if (!this.password) {
          this.$set(this.errFields, "password", "密码必须提供");
        } else if (!isvalidPassword(this.password)) {
          this.$set(
            this.errFields,
            "password",
            "6-18位，字母/数字/字符至少包含两类"
          );
        }
        if (!this.cfmpassword) {
          this.$set(this.errFields, "cfmpassword", "确认密码必须提供");
        }
        if (this.password !== this.cfmpassword) {
          this.$set(this.errFields, "password", "密码不一致");
          this.$set(this.errFields, "cfmpassword", "密码不一致");
          this.errMsg = "两次密码不一致";
          return;
        }
      }
      let errFields = Object.keys(this.errFields);
      if (errFields.length > 0) {
        if (errFields.length === 1) {
          this.errMsg = this.errFields[errFields[0]];
        } else {
          this.errMsg = "信息填写错误";
        }
        return;
      }
      if (!this.isCode) {
        return;
      }
      if (this.step === 2) {
        setPassword(
          this.phone,
          this.code,
          this.sliderCode,
          this.password,
          this.cfmpassword
        ).then(res => {
          if (res.success) {
            this.step = this.step + 1;
          } else {
            this.errMsg = res.msg;
          }
          this.resetCheck();
        });
      } else {
        this.step = this.step + 1;
      }
    },

    goStep(step) {
      if (this.step === 2 && step <= 2) {
        this.step = step;
      }
    },
    resetCheck() {
      this.code = "";
      this.canCode = false;
      this.sliderCode = "";
      this.isSlide = false;
      let slider = this.$refs.slider;
      if (slider) {
        slider.clean();
      }
    },
    clearErr() {
      this.errMsg = "";
      this.$set(this, "errFields", {});
    },

    slideFail() {
      this.sliderCode = "";
      this.isSlide = false;
      this.canCode = false;
    },
    slideCheck() {
      if (isPoneAvailable(this.phone)) {
        return true;
      } else {
        this.$set(this.errFields, "phone", "手机号码不正确");
        this.errMsg = "手机号码不正确";
        return false;
      }
    },
    slideSuccess(data) {
      if (!this.canCode) this.canCode = true;
      this.sliderCode = data.sliderCode;
      this.isSlide = true;
    },

    /**
     * 校验用户填写的验证码
     */
    doCheckCode() {
      if (this.code && this.code.length === 6) {
        checkCode("20", this.code, this.phone, this.sliderCode).then(res => {
          if (res.success) {
            this.isCode = true;
          } else {
            this.errMsg = res.msg;
          }
        });
      }
    },

    doSendCode() {
      if (this.canCode) {
        if (this.leftTime === undefined) {
          if (isPoneAvailable(this.phone)) {
            sendCode(this.sliderCode, this.phone, "20")
              .then(res => {
                if (res.success) {
                  this.leftTime = 60;
                  this.codeTip = this.leftTime + "s后可重发";
                  this.canCode = false;
                  // 启动定时器
                  this.tickTime = setInterval(() => {
                    if (this.leftTime > 0) {
                      this.leftTime = this.leftTime - 1;
                      this.codeTip = this.leftTime + "s后可重发";
                    } else {
                      this.leftTime = undefined;
                      this.codeTip = DEFAULT_TIP_TEXT;
                      clearInterval(this.tickTime);
                    }
                  }, 1000);
                } else {
                  this.errMsg = res.msg;
                }
              })
              .catch(() => {
                this.errMsg = "发送错误";
              });
          } else {
            this.$set(this, "errFields", {});
            this.$set(this.errFields, "phone", "手机号码错误");
            this.errMsg = "输入正确的手机号";
          }
          return;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.forget-container {
  max-width: 940px;
  margin: 0 auto;
  margin-top: 20px;
}
.forget-title {
  color: #0c9af4;
  margin-bottom: 20px;
}
.forget-input {
  margin-top: 50px;
}

.input-wrap {
  position: relative;
}

.input-wrap input {
  outline: none;
  border: 1px solid #cccccc;
  border-radius: 5px;
  line-height: 36px;
  box-sizing: border-box;
  padding: 0 10px;
  color: #333333;
}
.input-wrap input,
.input-border {
  margin-bottom: 16px;
  width: 280px;
}

.login-btn-container {
  padding-bottom: 30px;
}

.login-button {
  margin-top: 10px;
  width: 280px;
  line-height: 36px;
  background-color: #eef1f3;
  color: #666666;
  font-size: 14px;
  outline: none;
  border: 1px solid #cccccc;
  border-radius: 5px;
}

.login-button:focus {
  outline: none;
}

span.error {
  display: block;
  position: relative;
  top: 10px;
  color: red;
}

.login-tip-container {
  position: absolute;
  bottom: 10px;
  left: 20px;
  right: 50px;
}

.login-tip-container > span {
  font-size: 13px;
  margin-left: 5px;
  cursor: default;
}

.a-text {
  color: #0c9af4;
}

.tip-text {
  color: #c9c9c9;
}

.code-input {
  width: 160px !important;
  position: relative;
}

.code-tip {
  position: relative;
  margin-left: 20px;
  height: 36px;
  width: 100px;
  outline: none;
  border: 1px solid #cccccc;
  background-color: #eef1f3;
  border-radius: 5px;
  font-size: 14px;
}
.suss-icon {
  color: green;
  font-size: 30px;
}
.suss-text {
  color: green;
  font-size: 28px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 30px;
}
.login-link {
  color: #0c9af4;
}
/* 步骤 */
.step-left {
  margin-top: 30px;
  width: 40%;
  display: inline-block;
  text-align: left;
  position: relative;
}
.step-last {
  position: relative;
  width: 36px;
}
.active-step div.num,
.active-step div.line {
  background-color: #0c9af4 !important;
}
.active-step div.text {
  color: #0c9af4 !important;
}
.active-btn {
  background-color: #0c9af4;
  color: white;
}

.err-input {
  border-color: red !important;
}

.num {
  display: inline-block;
  border: 0px solid black;
  position: absolute;
  left: 0;
  height: 24px;
  width: 24px;
  text-align: center;
  border-radius: 12px;
  line-height: 22px;
  background: #c9c9c9;
  color: white;
  font-size: 14px;
  z-index: 100;
  cursor: default;
}
.text {
  text-align: left;
  margin-top: 10px;
  margin-left: -20px;
  font-size: 16px;
}
.line {
  display: inline-block;
  background: #c9c9c9;
  height: 2px;
  position: relative;
  top: -4px;
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .step-left-div {
    text-align: center;
  }
  .step-left {
    width: 30%;
  }
  .step-last {
    width: 36px;
  }
}
</style>
